<template>

	<div class="member">
		<div class="tit">
		<h5>Member Center  </h5>	
		</div>
		<div class="con">
			<ul>
				<li>
					<h6>MY DEAL</h6>
					<router-link to="/user/orders">
						<p :class="{'act':title=='1'}"><span></span>Order management </p>
					</router-link>
					<router-link to="/user/coll">
						<p :class="{'act':title=='2'}"><span></span> My collection</p>
					</router-link>
				<router-link to="/user/address">
					<p :class="{'act':title=='3'}"><span></span>Shopping address</p>
				</router-link>

				</li>
				
			</ul>
			<!-- <ul>
				<li>
					<h6>MY ASSETS</h6>
					<p><span></span>Integral</p>
					<p><span></span>Coupon</p>
				</li>
				
			</ul> -->
			<ul>
				<li>
					<h6>PERSONAL DATA</h6>
				<router-link to="/user/info">	<p :class="{'act':title=='6'}"><span></span>Basic information </p>	</router-link>
				<router-link to="/user/password">	<p :class="{'act':title=='7'}"><span></span>Account security </p></router-link>
				</li>
				
			</ul>
		</div>
	</div>
</template>
<script>


export default {
  props: {
	title:String,
  },
  methods: {
    getBarBtn(index) {
      this.barBtn = index;
    },
  },
};
</script>

<style lang='scss' scoped>
.member{
	width: 247px;
	height: 687px;
	background: #F8F8F8;
	padding: 30px;
	h5{
		line-height: 50px;
		background: url(../../assets/bot1.png) no-repeat bottom left;
	}
	.con{
		li{
			border-bottom:1px solid #eeeeee;
			padding: 20px;
		}
		h6{
			line-height: 40px;
		}
		p{
			display: flex;
			line-height: 40px;
			align-items: center;
			color: #777777;
			span{
				display: inline-block;
				width: 6px;
				height: 6px;
				background: #636363;
				border-radius: 50%;
				margin-right: 10px;
			}
		}
		.act{
			color: #000000;
		}
	}

}
</style>